/**
 * Mock Upload Complete Responses
 *
 * Custom mock export for uploadComplete endpoint.
 * Can be referenced via mock: "uploadCompleteMock" in YAML or discovered by convention.
 *
 * Sample responses from POST /upload/complete for development and testing.
 * These responses would be returned when the actual API endpoint is not yet available.
 *
 * The client sends only `{ uploadId }` — no success flag. The backend
 * performs a storage existence check and returns the verification result.
 *
 * Response shapes:
 *   - status 'completed' → includes `fileRecord` with the persisted file metadata
 *   - status 'failed'    → includes `error` with a machine-readable `code` and human-readable `message`
 */

export const MOCK_UPLOAD_COMPLETE = {
  status: 'completed' as const,
  fileRecord: {
    uploadId: 'up_8f3a2c1d-4e5b-6f7a-8b9c-0d1e2f3a4b5c',
    fileRecordId: 'fr_9e8d7c6b-5a4f-3e2d-1c0b-9a8f7e6d5c4b',
    fileName: 'sensor-photo.jpg',
    objectKey: 'attachments/images/device-DEV-001/sensor-photo.jpg',
    contentType: 'image/jpeg',
    fileSize: 2097152,
    checksum: 'a665a45920422f9d417e4867efdc4fb8a04a1f3fff1fa07e998e86f7f7a27ae3',
  },
};

export const MOCK_UPLOAD_COMPLETE_CHECKSUM_FAILURE = {
  status: 'failed' as const,
  error: {
    code: 'CHECKSUM_MISMATCH',
    message: 'File integrity check failed. The uploaded file checksum does not match the declared checksum.',
  },
};

export const MOCK_UPLOAD_COMPLETE_VERIFICATION_FAILURE = {
  status: 'failed' as const,
  error: {
    code: 'UPLOAD_NOT_VERIFIED',
    message: 'Upload could not be verified. The file was not found in storage after the expected upload window.',
  },
};
